var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFilled = function SvgFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 22a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM17 22a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM3.447 2.106a1 1 0 1 0-.894 1.788l1.003.502a1 1 0 0 1 .549.804l.734 8.072A3 3 0 0 0 7.826 16h8.665a3 3 0 0 0 2.885-2.176l1.221-4.275A2 2 0 0 0 18.674 7H6.277l-.18-1.981A3 3 0 0 0 4.45 2.607l-1.004-.501Z",
    fill: "#777E91"
  })));
};
export default SvgFilled;